import InstallationIcon from './component'

export default InstallationIcon
